import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

import { ProjectContext } from '#contexts/ProjectContext';
import { type ProjectConfigInput, type ProjectConfigOutput, ProjectConfigSchema } from '#schema/ProjectConfigSchema';

export interface ProjectProviderProps<ConfigType extends ProjectConfigInput> {
  config: ConfigType;
}

export function ProjectProvider<const ConfigType extends ProjectConfigInput>({
  children,
  config: inputConfig,
}: React.PropsWithChildren<ProjectProviderProps<ConfigType>>) {
  const config = ProjectConfigSchema.parse(inputConfig) as ProjectConfigOutput;
  return (
    <ProjectContext value={{ config }}>
      <MantineProvider
        defaultColorScheme={config?.defaultColorScheme}
        forceColorScheme={config?.forceColorScheme}
        theme={config?.theme}
      >
        <DatesProvider settings={{ locale: 'en', consistentWeeks: true }}>{children}</DatesProvider>
      </MantineProvider>
    </ProjectContext>
  );
}
